import { get, post } from "../../config/api";

class OrderService {
    static async getRecentOrders(restaurantId, filters) {
        const { page, count = 10 } = filters;
        let url = `/v1/billing/order/recent/${restaurantId}?page=${page}&count=${count}`;
        return await get({ url });
    }

    static async getOrderDetails(orderId) {
        const url = `/v1/billing/order/${orderId}`;
        return await get({ url });
    }

    static async abortOrder(orderId, data) {
        const url = `/v1/billing/order/abort/${orderId}`;
        return await post({ url, data })
    }

}

export default OrderService;